const initialState = {
	isFullscreen: false
};

export default function visibilityReducer(state = initialState, action) {
	switch (action.type) {
	case 'FULL_SCREEN':
		return {
			...state,
			isFullscreen: action.isExpanded
		};
	default:
		return state
	}
}